import { render, staticRenderFns } from "./StudentAward.vue?vue&type=template&id=1353c7d1"
import script from "./StudentAward.vue?vue&type=script&lang=js"
export * from "./StudentAward.vue?vue&type=script&lang=js"
import style0 from "./StudentAward.vue?vue&type=style&index=0&id=1353c7d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports